var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconModal',_vm._b({attrs:{"alertClass":"danger","iconClass":"fa-circle-exclamation"}},'IconModal',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }